var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g3, _path21, _path22, _path23, _g4, _path24, _path25, _path26, _g5, _path27, _path28, _g6, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000001625(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 60,
    viewBox: "0 0 182 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_2237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2279_2237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 10,
    width: 55,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2094 17.2229H64.2013C67.341 17.2229 69.9106 19.7562 69.9106 22.8516V47.3712C69.9106 50.4667 67.341 53 64.2013 53H20.8152C17.6755 53 15.106 50.4667 15.106 47.3712V17.3042C15.106 13.7761 18.0319 10.8914 21.6105 10.8914H26.9559L26.4945 14.7709L26.2132 17.1267L26.2057 17.2192L26.2094 17.2229Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2279_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9067 10.8914H15.1021V53H69.9067V10.8914Z",
    fill: "url(#paint0_linear_2279_2237)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3148 52.0791C66.4183 52.6598 65.3454 52.9963 64.2013 52.9963H20.8153C17.8218 52.9963 15.3498 50.696 15.121 47.8002C16.3739 52.2825 22.3532 51.8831 26.0144 51.8979L67.3148 52.0791Z",
    fill: "#0695CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.12 26.7903H69.9106V43.4104H60.12C55.4798 43.4104 51.6912 39.6751 51.6912 35.1004C51.6912 30.5256 55.4798 26.7903 60.12 26.7903Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1201 29.1461H70.1019C71.1485 29.1461 72.0038 29.9893 72.0038 31.0211V39.1832C72.0038 40.2151 71.1485 41.0583 70.1019 41.0583H60.1201C56.8003 41.0583 54.0807 38.3807 54.0807 35.104C54.0807 31.8311 56.7965 29.1498 60.1201 29.1498",
    fill: "url(#paint1_linear_2279_2237)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2279_2237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 29,
    width: 19,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1201 29.1461H70.1019C71.1485 29.1461 72.0038 29.9893 72.0038 31.0211V39.1832C72.0038 40.2151 71.1485 41.0583 70.1019 41.0583H60.1201C56.8003 41.0583 54.0807 38.3807 54.0807 35.104C54.0807 31.8311 56.7965 29.1498 60.1201 29.1498",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2279_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 29.1461H54.0807V41.0546H72V29.1461Z",
    fill: "url(#paint2_linear_2279_2237)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0888 25.4367C32.0044 25.4367 27.0717 30.3 27.0717 36.2986C27.0717 39.5863 28.5534 42.5339 30.8941 44.5235C30.2601 42.3933 29.6262 40.2631 28.9885 38.1329C28.966 38.059 28.8385 37.6115 29.1048 37.1677C29.4086 36.6684 29.9563 36.5944 30.0201 36.587H45.6062C45.6812 36.587 46.3789 36.5649 46.8328 37.1196C47.1854 37.5523 47.2492 38.1588 47.0016 38.6803L45.2611 44.5383C47.6093 42.545 49.1023 39.5937 49.1023 36.2949C49.1023 30.2963 44.1695 25.433 38.0851 25.433L38.0888 25.4367ZM43.6743 35.4147H41.3186C41.4949 32.2342 39.6381 30.0226 38.2351 29.993C36.8134 29.9597 34.8103 32.1491 34.9304 35.4147H32.4696C32.4996 34.6085 32.6834 32.8444 33.91 31.1432C34.4615 30.3813 35.9694 28.2955 38.2201 28.3399C40.4746 28.388 41.8925 30.5404 42.4139 31.3281C43.4943 32.9664 43.6481 34.6159 43.6706 35.411L43.6743 35.4147Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.997 44.9303C43.6594 44.1981 42.9129 43.7284 42.1026 43.7395C41.3111 43.7506 40.5946 44.2166 40.2645 44.9303C40.1258 43.7506 41.0448 42.7557 42.0801 42.7299C43.1454 42.704 44.1358 43.7136 43.997 44.9303Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3858 44.9304C36.0857 44.1759 35.3467 43.6767 34.5252 43.6767C33.7 43.6767 32.9535 44.1759 32.6534 44.9304C32.4733 43.6767 33.4636 42.6227 34.514 42.619C35.5681 42.619 36.5659 43.6693 36.3858 44.9304Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.12 43.4104C56.834 43.4104 53.9756 41.539 52.5876 38.8208C54.0994 44.0354 58.3307 44.6567 62.9559 44.6567H69.9106V43.4067H60.12V43.4104Z",
    fill: "#67CEF6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1082 33.5803C63.3873 33.5803 64.4227 34.601 64.4227 35.8622C64.4227 37.1233 63.3873 38.144 62.1082 38.144C60.829 38.144 59.7937 37.1233 59.7937 35.8622C59.7937 34.601 60.829 33.5803 62.1082 33.5803Z",
    fill: "#870000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9768 32.9036C63.256 32.9036 64.2913 33.9243 64.2913 35.1854C64.2913 36.4465 63.256 37.4672 61.9768 37.4672C60.6977 37.4672 59.6624 36.4465 59.6624 35.1854C59.6624 33.9243 60.6977 32.9036 61.9768 32.9036Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9985 25.8583C22.9985 27.0418 22.0269 27.9996 20.8266 27.9996H8.76653C7.56616 27.9996 6.5946 27.0418 6.5946 25.8583C6.5946 24.6749 7.56616 23.717 8.76653 23.717H20.8266C22.0269 23.717 22.9985 24.6749 22.9985 25.8583Z",
    fill: "#0099FF",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.589 14.7222C29.589 15.2638 29.1791 15.7037 28.6758 15.7037H23.5982C23.0949 15.7037 22.6849 15.2638 22.6849 14.7222C22.6849 14.1806 23.0949 13.7407 23.5982 13.7407H28.6758C29.1791 13.7407 29.589 14.1806 29.589 14.7222Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4642 46.9792C21.4642 47.9223 20.6877 48.6878 19.7311 48.6878H10.1244C9.16785 48.6878 8.39136 47.9223 8.39136 46.9792C8.39136 46.0362 9.16785 45.2706 10.1244 45.2706H19.7349C20.6915 45.2706 21.4679 46.0362 21.4679 46.9792",
    fill: "#0099FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4642 46.9792C21.4642 47.9223 20.6877 48.6878 19.7311 48.6878H10.1244C9.16785 48.6878 8.39136 47.9223 8.39136 46.9792C8.39136 46.0362 9.16785 45.2706 10.1244 45.2706H19.7349C20.6915 45.2706 21.4679 46.0362 21.4679 46.9792",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5548 36.5353H2.7345H19.5548Z",
    fill: "#0099FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5548 36.5353H2.7345",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5586 38.6766H2.73455C1.53418 38.6766 0.562622 37.7187 0.562622 36.5353C0.562622 35.3518 1.53418 34.394 2.73455 34.394H19.5586C20.7589 34.394 21.7305 35.3518 21.7305 36.5353C21.7305 37.7187 20.7589 38.6766 19.5586 38.6766Z",
    fill: "#0099FF",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5464 13.3545L44.8977 2.63686C45.768 0.49186 48.2588 -0.55845 50.4345 0.29955L67.6561 7.09328C69.8318 7.95128 70.8971 10.4069 70.0268 12.5519L69.1416 14.7302C67.7611 13.8574 66.1219 13.3508 64.3663 13.3508H40.5464V13.3545Z",
    fill: "url(#paint3_linear_2279_2237)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2279_2237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 31,
    height: 15
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5464 13.3545L44.8977 2.63686C45.768 0.49186 48.2588 -0.55845 50.4345 0.29955L67.6561 7.09328C69.8318 7.95128 70.8971 10.4069 70.0268 12.5519L69.1416 14.7302C67.7611 13.8574 66.1219 13.3508 64.3663 13.3508H40.5464V13.3545Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2279_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8971 -0.558472H40.5464V14.7339H70.8971V-0.558472Z",
    fill: "url(#paint4_linear_2279_2237)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8659 0.469666L55.3035 2.22265L50.9034 13.3545H45.7755L50.8659 0.469666Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0997 13.3545L36.919 5.16652C37.4217 2.91057 39.7024 1.46824 41.9906 1.96381L42.5496 2.08585L37.9731 13.3582H35.0997V13.3545Z",
    fill: "url(#paint5_linear_2279_2237)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2279_2237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 1,
    width: 8,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0997 13.3545L36.919 5.16652C37.4217 2.91057 39.7024 1.46824 41.9906 1.96381L42.5496 2.08585L37.9731 13.3582H35.0997V13.3545Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2279_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5496 1.46826H35.0997V13.3545H42.5496V1.46826Z",
    fill: "url(#paint6_linear_2279_2237)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5458 2.08215L37.9731 13.3545H35.0997L42.5458 2.08215Z",
    fill: "#1E003D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3829 13.3545L30.0431 7.80338C30.3132 5.52155 32.4214 3.86842 34.7321 4.1162C34.6758 4.29372 34.6271 4.47494 34.5858 4.65985L32.654 13.3508H29.3829V13.3545Z",
    fill: "url(#paint7_linear_2279_2237)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2279_2237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 4,
    width: 6,
    height: 10
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3829 13.3545L30.0431 7.80338C30.3132 5.52155 32.4214 3.86842 34.7321 4.1162C34.6758 4.29372 34.6271 4.47494 34.5858 4.65985L32.654 13.3508H29.3829V13.3545Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2279_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7321 3.87213H29.3829V13.3545H34.7321V3.87213Z",
    fill: "url(#paint8_linear_2279_2237)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7284 4.11621L32.654 13.3545H29.3829L34.7284 4.11621Z",
    fill: "#1E003D"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.472 53.126C81.632 53.126 80.876 52.982 80.204 52.694C79.532 52.394 79.004 51.974 78.62 51.434C78.236 50.894 78.044 50.264 78.044 49.544H80.24C80.288 50.084 80.498 50.528 80.87 50.876C81.254 51.224 81.788 51.398 82.472 51.398C83.18 51.398 83.732 51.23 84.128 50.894C84.524 50.546 84.722 50.102 84.722 49.562C84.722 49.142 84.596 48.8 84.344 48.536C84.104 48.272 83.798 48.068 83.426 47.924C83.066 47.78 82.562 47.624 81.914 47.456C81.098 47.24 80.432 47.024 79.916 46.808C79.412 46.58 78.98 46.232 78.62 45.764C78.26 45.296 78.08 44.672 78.08 43.892C78.08 43.172 78.26 42.542 78.62 42.002C78.98 41.462 79.484 41.048 80.132 40.76C80.78 40.472 81.53 40.328 82.382 40.328C83.594 40.328 84.584 40.634 85.352 41.246C86.132 41.846 86.564 42.674 86.648 43.73H84.38C84.344 43.274 84.128 42.884 83.732 42.56C83.336 42.236 82.814 42.074 82.166 42.074C81.578 42.074 81.098 42.224 80.726 42.524C80.354 42.824 80.168 43.256 80.168 43.82C80.168 44.204 80.282 44.522 80.51 44.774C80.75 45.014 81.05 45.206 81.41 45.35C81.77 45.494 82.262 45.65 82.886 45.818C83.714 46.046 84.386 46.274 84.902 46.502C85.43 46.73 85.874 47.084 86.234 47.564C86.606 48.032 86.792 48.662 86.792 49.454C86.792 50.09 86.618 50.69 86.27 51.254C85.934 51.818 85.436 52.274 84.776 52.622C84.128 52.958 83.36 53.126 82.472 53.126ZM98.3033 47.798C98.3033 48.17 98.2793 48.506 98.2313 48.806H90.6533C90.7133 49.598 91.0073 50.234 91.5353 50.714C92.0633 51.194 92.7113 51.434 93.4793 51.434C94.5833 51.434 95.3633 50.972 95.8193 50.048H98.0333C97.7333 50.96 97.1873 51.71 96.3953 52.298C95.6153 52.874 94.6433 53.162 93.4793 53.162C92.5313 53.162 91.6793 52.952 90.9233 52.532C90.1793 52.1 89.5913 51.5 89.1593 50.732C88.7393 49.952 88.5293 49.052 88.5293 48.032C88.5293 47.012 88.7333 46.118 89.1413 45.35C89.5613 44.57 90.1433 43.97 90.8873 43.55C91.6433 43.13 92.5073 42.92 93.4793 42.92C94.4153 42.92 95.2493 43.124 95.9813 43.532C96.7133 43.94 97.2833 44.516 97.6913 45.26C98.0993 45.992 98.3033 46.838 98.3033 47.798ZM96.1613 47.15C96.1493 46.394 95.8793 45.788 95.3513 45.332C94.8233 44.876 94.1693 44.648 93.3893 44.648C92.6813 44.648 92.0753 44.876 91.5713 45.332C91.0673 45.776 90.7673 46.382 90.6713 47.15H96.1613ZM102.375 39.68V53H100.323V39.68H102.375ZM107.121 39.68V53H105.069V39.68H107.121ZM118.905 47.798C118.905 48.17 118.881 48.506 118.833 48.806H111.255C111.315 49.598 111.609 50.234 112.137 50.714C112.665 51.194 113.313 51.434 114.081 51.434C115.185 51.434 115.965 50.972 116.421 50.048H118.635C118.335 50.96 117.789 51.71 116.997 52.298C116.217 52.874 115.245 53.162 114.081 53.162C113.133 53.162 112.281 52.952 111.525 52.532C110.781 52.1 110.193 51.5 109.761 50.732C109.341 49.952 109.131 49.052 109.131 48.032C109.131 47.012 109.335 46.118 109.743 45.35C110.163 44.57 110.745 43.97 111.489 43.55C112.245 43.13 113.109 42.92 114.081 42.92C115.017 42.92 115.851 43.124 116.583 43.532C117.315 43.94 117.885 44.516 118.293 45.26C118.701 45.992 118.905 46.838 118.905 47.798ZM116.763 47.15C116.751 46.394 116.481 45.788 115.953 45.332C115.425 44.876 114.771 44.648 113.991 44.648C113.283 44.648 112.677 44.876 112.173 45.332C111.669 45.776 111.369 46.382 111.273 47.15H116.763ZM122.976 44.522C123.276 44.018 123.672 43.628 124.164 43.352C124.668 43.064 125.262 42.92 125.946 42.92V45.044H125.424C124.62 45.044 124.008 45.248 123.588 45.656C123.18 46.064 122.976 46.772 122.976 47.78V53H120.924V43.082H122.976V44.522ZM141.256 44.216C141.256 44.852 141.106 45.452 140.806 46.016C140.506 46.58 140.026 47.042 139.366 47.402C138.706 47.75 137.86 47.924 136.828 47.924H134.56V53H132.508V40.49H136.828C137.788 40.49 138.598 40.658 139.258 40.994C139.93 41.318 140.428 41.762 140.752 42.326C141.088 42.89 141.256 43.52 141.256 44.216ZM136.828 46.25C137.608 46.25 138.19 46.076 138.574 45.728C138.958 45.368 139.15 44.864 139.15 44.216C139.15 42.848 138.376 42.164 136.828 42.164H134.56V46.25H136.828ZM142.529 47.996C142.529 47 142.733 46.118 143.141 45.35C143.561 44.582 144.125 43.988 144.833 43.568C145.553 43.136 146.345 42.92 147.209 42.92C147.989 42.92 148.667 43.076 149.243 43.388C149.831 43.688 150.299 44.066 150.647 44.522V43.082H152.717V53H150.647V51.524C150.299 51.992 149.825 52.382 149.225 52.694C148.625 53.006 147.941 53.162 147.173 53.162C146.321 53.162 145.541 52.946 144.833 52.514C144.125 52.07 143.561 51.458 143.141 50.678C142.733 49.886 142.529 48.992 142.529 47.996ZM150.647 48.032C150.647 47.348 150.503 46.754 150.215 46.25C149.939 45.746 149.573 45.362 149.117 45.098C148.661 44.834 148.169 44.702 147.641 44.702C147.113 44.702 146.621 44.834 146.165 45.098C145.709 45.35 145.337 45.728 145.049 46.232C144.773 46.724 144.635 47.312 144.635 47.996C144.635 48.68 144.773 49.28 145.049 49.796C145.337 50.312 145.709 50.708 146.165 50.984C146.633 51.248 147.125 51.38 147.641 51.38C148.169 51.38 148.661 51.248 149.117 50.984C149.573 50.72 149.939 50.336 150.215 49.832C150.503 49.316 150.647 48.716 150.647 48.032ZM160.417 42.92C161.197 42.92 161.893 43.082 162.505 43.406C163.129 43.73 163.615 44.21 163.963 44.846C164.311 45.482 164.485 46.25 164.485 47.15V53H162.451V47.456C162.451 46.568 162.229 45.89 161.785 45.422C161.341 44.942 160.735 44.702 159.967 44.702C159.199 44.702 158.587 44.942 158.131 45.422C157.687 45.89 157.465 46.568 157.465 47.456V53H155.413V43.082H157.465V44.216C157.801 43.808 158.227 43.49 158.743 43.262C159.271 43.034 159.829 42.92 160.417 42.92ZM176.192 47.798C176.192 48.17 176.168 48.506 176.12 48.806H168.542C168.602 49.598 168.896 50.234 169.424 50.714C169.952 51.194 170.6 51.434 171.368 51.434C172.472 51.434 173.252 50.972 173.708 50.048H175.922C175.622 50.96 175.076 51.71 174.284 52.298C173.504 52.874 172.532 53.162 171.368 53.162C170.42 53.162 169.568 52.952 168.812 52.532C168.068 52.1 167.48 51.5 167.048 50.732C166.628 49.952 166.418 49.052 166.418 48.032C166.418 47.012 166.622 46.118 167.03 45.35C167.45 44.57 168.032 43.97 168.776 43.55C169.532 43.13 170.396 42.92 171.368 42.92C172.304 42.92 173.138 43.124 173.87 43.532C174.602 43.94 175.172 44.516 175.58 45.26C175.988 45.992 176.192 46.838 176.192 47.798ZM174.05 47.15C174.038 46.394 173.768 45.788 173.24 45.332C172.712 44.876 172.058 44.648 171.278 44.648C170.57 44.648 169.964 44.876 169.46 45.332C168.956 45.776 168.656 46.382 168.56 47.15H174.05ZM180.263 39.68V53H178.211V39.68H180.263Z",
    fill: "#0099FF"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2279_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.479 32.5779H106.835V25.9487C106.835 25.004 106.483 24.192 105.777 23.5126C105.07 22.8291 104.231 22.4915 103.256 22.4915C102.141 22.4915 101.207 22.9176 100.455 23.7618C99.9132 24.3729 99.6488 25.1729 99.6488 25.9809V32.5819H96.0042V25.9447C96.0042 23.9869 96.7066 22.3307 98.1116 20.9759C99.5165 19.6211 101.227 18.9417 103.244 18.9417C105.26 18.9417 106.971 19.6211 108.376 20.9759C109.781 22.3307 110.483 23.9869 110.483 25.9447V32.5819L110.479 32.5779Z",
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.306 28.5498C123.306 29.394 123.017 30.1578 122.442 30.8412C121.289 32.2121 119.653 32.8673 117.525 32.8151C116.678 32.799 115.756 32.6141 114.756 32.2643C113.756 31.9146 112.942 31.4764 112.31 30.9498L114.335 28.401C115.306 29.2935 116.343 29.7397 117.442 29.7397H117.525C117.975 29.7397 118.38 29.6593 118.74 29.5025C119.207 29.2935 119.442 28.996 119.442 28.6101V28.5055C119.388 28.1035 119.107 27.8141 118.603 27.6372C118.405 27.601 117.983 27.5246 117.335 27.4C116.525 27.2432 115.839 27.0503 115.281 26.8211C113.641 26.1377 112.822 24.9397 112.822 23.2191C112.822 21.4985 113.661 20.3367 115.335 19.5126C116.074 19.1467 116.876 18.9538 117.74 18.9337C118.641 18.9176 119.574 19.0663 120.55 19.3799C121.665 19.7498 122.459 20.2281 122.926 20.8231L120.496 22.9498C119.864 22.3186 119.182 22.005 118.442 22.005C117.289 22.005 116.715 22.3749 116.715 23.1106V23.1628C116.715 23.5126 117.182 23.8141 118.12 24.0593C118.19 24.0754 118.785 24.192 119.901 24.401C122.169 24.8231 123.306 26.1739 123.306 28.4573V28.5377V28.5498Z",
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.438 32.5779C130.422 32.5779 128.711 31.8985 127.306 30.5437C125.901 29.1889 125.198 27.5286 125.198 25.5709V13H128.843V18.9417H132.434V21.9648H128.843V25.5668C128.843 26.5317 129.194 27.3477 129.897 28.0231C130.599 28.6985 131.446 29.0362 132.434 29.0362V32.5819L132.438 32.5779Z",
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.665 32.5779H147.789L147.025 30.5276C145.583 32.1759 143.748 33 141.512 33C139.496 33 137.789 32.3166 136.393 30.9498C134.996 29.5829 134.297 27.9266 134.297 25.9849C134.297 24.4975 134.731 23.1508 135.595 21.9528C136.459 20.7548 137.612 19.8985 139.054 19.392C139.901 19.0945 140.727 18.9457 141.537 18.9457C143.066 18.9457 144.45 19.3719 145.682 20.2201C146.913 21.0684 147.793 22.194 148.314 23.597L151.665 32.5819V32.5779ZM145.103 25.9689C145.103 24.7387 144.591 23.7779 143.562 23.0945C142.967 22.6885 142.285 22.4874 141.508 22.4874C140.248 22.4874 139.277 22.9819 138.591 23.9628C138.14 24.606 137.926 25.3015 137.942 26.0613C137.971 27.2231 138.632 28.3126 139.649 28.9236C140.314 29.3256 141.029 29.4985 141.793 29.4382C142.715 29.3699 143.587 28.9397 144.207 28.2724C144.826 27.605 145.099 26.8573 145.099 25.9689H145.103Z",
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.798 22.4834C159.686 22.4834 158.756 22.9055 158.008 23.7538C157.467 24.3648 157.207 25.1648 157.207 25.9729V32.5779H153.562V25.9407C153.562 23.9829 154.264 22.3266 155.669 20.9719C157.074 19.6171 158.785 18.9377 160.802 18.9377V22.4794L160.798 22.4834Z",
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 32.5779H176.124L175.359 30.5276C173.917 32.1759 172.083 33 169.847 33C167.831 33 166.124 32.3166 164.727 30.9498C163.331 29.5829 162.632 27.9266 162.632 25.9849C162.632 24.4975 163.066 23.1508 163.93 21.9528C164.793 20.7548 165.946 19.8985 167.388 19.392C168.236 19.0945 169.062 18.9457 169.872 18.9457C171.401 18.9457 172.785 19.3719 174.017 20.2201C175.248 21.0684 176.128 22.194 176.649 23.597L180 32.5819V32.5779ZM173.438 25.9689C173.438 24.7387 172.926 23.7779 171.897 23.0945C171.302 22.6885 170.62 22.4874 169.843 22.4874C168.583 22.4874 167.612 22.9819 166.926 23.9628C166.475 24.606 166.26 25.3015 166.277 26.0613C166.306 27.2231 166.967 28.3126 167.983 28.9236C168.649 29.3256 169.364 29.4985 170.128 29.4382C171.05 29.3699 171.921 28.9397 172.541 28.2724C173.161 27.605 173.434 26.8573 173.434 25.9689H173.438Z",
    fill: "#0099FF"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85.668 33.154C84.216 33.154 82.8813 32.8167 81.664 32.142C80.4613 31.4673 79.5007 30.5287 78.782 29.326C78.078 28.1087 77.726 26.7447 77.726 25.234C77.726 23.7233 78.078 22.3667 78.782 21.164C79.5007 19.9613 80.4613 19.0227 81.664 18.348C82.8813 17.6733 84.216 17.336 85.668 17.336C87.12 17.336 88.4473 17.6733 89.65 18.348C90.8673 19.0227 91.8207 19.9613 92.51 21.164C93.214 22.3667 93.566 23.7233 93.566 25.234C93.566 26.7447 93.214 28.1087 92.51 29.326C91.806 30.5287 90.8527 31.4673 89.65 32.142C88.4473 32.8167 87.12 33.154 85.668 33.154ZM85.668 29.722C86.9 29.722 87.8827 29.3113 88.616 28.49C89.364 27.6687 89.738 26.5833 89.738 25.234C89.738 23.87 89.364 22.7847 88.616 21.978C87.8827 21.1567 86.9 20.746 85.668 20.746C84.4213 20.746 83.424 21.1493 82.676 21.956C81.9427 22.7627 81.576 23.8553 81.576 25.234C81.576 26.598 81.9427 27.6907 82.676 28.512C83.424 29.3187 84.4213 29.722 85.668 29.722Z",
    fill: "#0099FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2279_2237",
    x1: 15.1021,
    y1: 31.9457,
    x2: 69.9104,
    y2: 31.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2279_2237",
    x1: 54.0807,
    y1: 35.1003,
    x2: 72,
    y2: 35.1003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2279_2237",
    x1: 79.6937,
    y1: 34.6159,
    x2: 44.2723,
    y2: 35.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2279_2237",
    x1: 40.5464,
    y1: 7.36696,
    x2: 70.3269,
    y2: 7.36696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2279_2237",
    x1: 40.5464,
    y1: 7.08587,
    x2: 70.8971,
    y2: 7.08587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2279_2237",
    x1: 35.0997,
    y1: 7.60738,
    x2: 42.5458,
    y2: 7.60738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2279_2237",
    x1: 57.5355,
    y1: 29.0093,
    x2: 33.7517,
    y2: 0.76112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2279_2237",
    x1: 29.3829,
    y1: 8.72426,
    x2: 34.7284,
    y2: 8.72426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2279_2237",
    x1: 52.2163,
    y1: 49.25,
    x2: 27.5629,
    y2: -1.88137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BFEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_2237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 53,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2279_2237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 20,
    fill: "white",
    transform: "translate(96 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000001625);
export default __webpack_public_path__ + "static/media/Group 1000001625.5750577e199a0d586e1a931b965d935c.svg";
export { ForwardRef as ReactComponent };